import { Channel, ChannelMemberResponse } from "stream-chat"
import { format, isToday, isYesterday } from "date-fns"

export const getTimeStamp = (channel: Channel) => {
  const date = channel?.state?.last_message_at
  if (!date) return ""

  if (isToday(date)) {
    return format(date, "p")
  } else if (isYesterday(date)) {
    return "Yesterday"
  } else {
    return format(date, "MMM d") // Format as "Nov 2" for earlier dates
  }
}

export const getChannelName = (members: ChannelMemberResponse[]) => {
  const defaultName = ""

  if (!members.length || members.length === 1) {
    return members[0]?.user?.name || defaultName
  }

  return `${members[0]?.user?.name || defaultName}, ${members[1]?.user?.name || defaultName}`
}
